import React, { useEffect, useState } from 'react';
import { Button, Alert } from 'antd';
import { Pencil } from 'lucide-react';
import cx from 'classnames';
import styles from './index.module.css';
import { navigateToProjectSettingsSidebarTab } from './EmptyState';

type Props = {
  show: boolean;
  isAcceptingFeedback: boolean;
  manageProject: boolean;
};

export const AcceptingFeedbackShortcut: React.FC<Props> = ({
  show,
  isAcceptingFeedback,
  manageProject
}) => {
  const [acceptingFeedback, setAcceptingFeedback] = useState<boolean>(
    isAcceptingFeedback
  );

  useEffect(() => {
    if (window.project_board_props.setAcceptingFeedback) return;
    window.project_board_props.setAcceptingFeedback = setAcceptingFeedback;
  }, []);

  useEffect(() => {
    setAcceptingFeedback(isAcceptingFeedback);
  }, [isAcceptingFeedback]);

  if (!show) return null;

  const isPaused = !acceptingFeedback;
  const message = isPaused
    ? 'Client feedback paused'
    : 'Accepting client feedback';

  const statusDot = (
    <span
      aria-hidden="true"
      className={cx(styles.feedbackStatusDot, {
        [styles.acceptingFeedbackDot]: !isPaused,
        [styles.pausedFeedbackDot]: isPaused
      })}
    />
  );

  return (
    <Alert
      message={
        <span className={styles.feedbackStatusMessage}>{message}</span>
      }
      type={isPaused ? 'warning' : 'success'}
      showIcon
      icon={
        manageProject ? (
          <Button
            type="link"
            size="small"
            aria-label="Edit feedback settings"
            onClick={() => navigateToProjectSettingsSidebarTab(true)}
            className={styles.editAcceptingFeedbackButton}
          >
            {statusDot}
            <Pencil
              size={14}
              aria-hidden="true"
              className={styles.editAcceptingFeedbackIcon}
            />
          </Button>
        ) : (
          statusDot
        )
      }
      className={cx(styles.feedbackStatus, {
        [styles.acceptingFeedbackStatus]: !isPaused,
        [styles.pausedFeedbackStatus]: isPaused,
        [styles.editableFeedbackStatus]: manageProject
      })}
    />
  );
};
